import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { ReserveService } from "../../providers/reserve.service";

@Pipe({
  name: "reserveExtraById"
})
export class reserveExtraByIdPipe implements PipeTransform {
  constructor(private reserveService: ReserveService) { }

  transform(id: string = null, clientId: string, eventId: string): Observable<any> {
    if (id) {
      return this.reserveService.getExtraById(clientId, id, eventId);
    } else {
      return Observable.empty();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/reserve-extra/reserve-extra.ts